// extracted by mini-css-extract-plugin
export var address = "TheNeighborhood-module--address--ee57c";
export var arrow = "TheNeighborhood-module--arrow--f899a";
export var backButton = "TheNeighborhood-module--backButton--3d6a4";
export var cardCarousel = "TheNeighborhood-module--cardCarousel--5f6b5";
export var cardWrapper = "TheNeighborhood-module--cardWrapper--4377f";
export var carousel = "TheNeighborhood-module--carousel--16a5c";
export var container = "TheNeighborhood-module--container--20b0a";
export var decor = "TheNeighborhood-module--decor--04fae";
export var description = "TheNeighborhood-module--description--46cc4";
export var directions = "TheNeighborhood-module--directions--55994";
export var divider = "TheNeighborhood-module--divider--61b44";
export var hamburger = "TheNeighborhood-module--hamburger--e9af0";
export var image = "TheNeighborhood-module--image--022b9";
export var info = "TheNeighborhood-module--info--3b9cc";
export var infoBlock = "TheNeighborhood-module--infoBlock--56828";
export var infoCarousel = "TheNeighborhood-module--infoCarousel--efdfc";
export var infoWrapper = "TheNeighborhood-module--infoWrapper--494c8";
export var name = "TheNeighborhood-module--name--786e6";
export var nextButton = "TheNeighborhood-module--nextButton--14452";
export var reactCalendarMonthViewDays = "TheNeighborhood-module--react-calendar__month-view__days--8427a";
export var reactCalendarTile = "TheNeighborhood-module--react-calendar__tile--46803";
export var reactCalendarTileActive = "TheNeighborhood-module--react-calendar__tile--active--38840";
export var relativeWrapper = "TheNeighborhood-module--relativeWrapper--8e6e8";
export var units = "TheNeighborhood-module--units--763ed";